// import { BlogSvg, BonusUISvg, ButtonsSvg, CalanderSvg, ChartsSvg, ChatSvg, ContactSvg, EcommerceSvg, EditorsSvg, EmailSvg, FAQSvg, FilemanagerSvg, FormsSvg, GallarySvg, HeaderBookmarkSvg, HomeSvg, IconsSvg, JobsearchSvg, KnowledgebaseSvg, LearningSvg, MapsSvg, OthersSvg, ProjectSvg, SamplePageSvg, SearchResultSvg, SocialappSvg, SupportTicketSvg, TablesSvg, TaskSvg, TodoSvg, UiKitsSvg, UsersComponentSvg, WidgetsSvg } from '../../Data/svgIcons';
import { ButtonsSvg, BlogSvg, GallarySvg, HomeSvg, MapsSvg, SupportTicketSvg, ContactSvg, EcommerceSvg, UsersComponentSvg, EmailSvg } from '../../Data/svgIcons';

export const MENUITEMCS = [
    {
        menutitle: 'DashBoards',
        Items: [
            { path: `${process.env.PUBLIC_URL}/dashboard`, bookmark: true, icon: HomeSvg, title: 'Dashboards', type: 'link' }
        ]
    },
    {
        menutitle: 'Daftar Reservasi',
        Items: [
            { path: `${process.env.PUBLIC_URL}/orders`, icon: EmailSvg, type: 'link', active: false, title: 'Daftar Reservasi' },
        ]
    },
];